import { ArrowDown, ArrowUp } from "lucide-react/dist/cjs/lucide-react";
import React, {useState} from "react";
import { ColorRing } from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setIsPreFiltered, setPreDefinedFilter } from "../../redux/slices/pricingSlice";
import { Tooltip } from "@mui/material";

const TurnReport = ({ DataisLoaded, items, setState, filterHash , rowFilters }) => {

  const [sortConfig, setSortConfig] = useState({
    table: null,
    key: null,
    direction: null,
    clicks: 0
  });
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const handleSearchClick = (search) => {
    // console.log('inventory clicked:', search);
    dispatch(setIsPreFiltered(true));
    dispatch(setPreDefinedFilter(search));
    navigate(`/price_co-pilot?page=0`);
    // Implement navigation or actions with the selected search
    // We need to update the 
  };
  // function to get background color between red to green based on values
  const getBgColor = (min, max, value) => {
    let rgb_string = "";
    if (value === max) {
      rgb_string = "rgba(100,255,90,0.7)";
    } else if (value === min) {
      rgb_string = "rgba(255,100,90,0.7)";
    } else {
      const range = max - min;
      const percentage = parseInt(((value - min) / range) * 100);
      let red, green;
      if (percentage < 50) {
        // get color between red to yellow
        red = 155 + (100 - percentage);
        green = 155 * (percentage / 50) + 100;
      } else {
        // get color between yellow to green
        red = (155 * (100 - percentage)) / 50 + 100;
        green = 155 + percentage;
      }
      rgb_string = `rgba(${red},${green},90,0.7)`;
    }
    return rgb_string;
  };

  const parseCurrencyValue = (currencyString) => {
    if (!currencyString || currencyString === "$0") return 0;
    return parseFloat(currencyString.replace(/[$,]/g, ''));
  };

  const parseNumericValue = (value) => {
    if (value === "NA" || value === null || value === undefined) return -1;
    return parseFloat(value);
  };

  const handleSort = (tableKey, columnKey) => {
    let direction = null;
    let clicks = 1;

    if (sortConfig.table === tableKey && sortConfig.key === columnKey) {
      clicks = (sortConfig.clicks + 1) % 3;
      if (clicks === 1) direction = 'asc';
      else if (clicks === 2) direction = 'desc';
    } else {
      direction = 'asc';
    }

    setSortConfig({
      table: tableKey,
      key: columnKey,
      direction,
      clicks
    });
  };

  const getSortedData = (tableKey, data) => {
    if (sortConfig.table !== tableKey || !sortConfig.direction) {
      return data;
    }

    return [...data].sort((a, b) => {
      let aValue, bValue;
      
      switch(sortConfig.key) {
        case 'name':
          aValue = a.name.toLowerCase();
          bValue = b.name.toLowerCase();
          break;
        case 'count':
          aValue = a.count;
          bValue = b.count;
          break;
        case 'value':
          aValue = parseCurrencyValue(a.total_amount);
          bValue = parseCurrencyValue(b.total_amount);
          break;
        case 'sale_count':
          aValue = a.sale_count;
          bValue = b.sale_count;
          break;
        case 'sale_value':
          aValue = parseCurrencyValue(a.sale_total_amount);
          bValue = parseCurrencyValue(b.sale_total_amount);
          break;
        case 'turn':
          aValue = parseNumericValue(a.turn);
          bValue = parseNumericValue(b.turn);
          break;
        default:
          return 0;
      }

      if (sortConfig.direction === 'asc') {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
      return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
    });
  };

  const getSortIcon = (tableKey, columnKey) => {
    if (sortConfig.table !== tableKey || sortConfig.key !== columnKey) {
      return ;
    }
    if (sortConfig.direction === 'asc') {
      return <ArrowUp className="inline h-3 w-3 text-blue-600" />;
    }
    if (sortConfig.direction === 'desc') {
      return <ArrowDown className="inline h-3 w-3 text-blue-600" />;
    }
    return;
  };

  const handleRowClick = (key, element) => {
    const TABLE_FILTER_MAP = {
      lab: "diamond#cert",
      shape: "diamond#shape",
      color: "diamond#color",
      clarity: "diamond#clarity",
      carats: "gem#carats",
      milky: "diamond#milky",
      shade: "diamond#shade",
      make: "diamond#make",
      fluor: "diamond#fluor",
      bic: "diamond#black_in_center",
      bis: "diamond#black_in_side",
      wis: "diamond#white_in_side",
      wic: "diamond#white_in_center"
    };
    // Get the corresponding filter property for the current table
    const filterProperty = TABLE_FILTER_MAP[key];

    if (filterProperty) {
      // Create a filter object
      let currentRowfilter = {};
      if(filterProperty === 'gem#carats'){
        let carat_range = element.key.split("-");
        currentRowfilter = {
          [filterProperty]: [{ to: carat_range[1], from: carat_range[0] }]
        };
      }else{
        currentRowfilter = {
          [filterProperty]: Array.isArray(element.key) ? element.key : [element.key]
        };
      }
      setState((prevState) => ({
        ...prevState,
        rowFilter: currentRowfilter, // Set new rowFilter
      }));
      // console.log(`Row clicked ${currentRowfilter}`);
      // Navigate to Pricing co-Pilot, query updated filters and show the updated filters
      const transformedFilters = transformFilters(updateCombinedFilters(currentRowfilter));
      handleSearchClick(transformedFilters)
    }
  };

  let defaultFilter = {};

  if (filterHash ) {
    defaultFilter = filterHash.item_filter;
  } else defaultFilter = { discrete: { state: ["for_sale"] } };

  const updateCombinedFilters = (rowFilter) => {
    const filcombinedFilters = {
      ...defaultFilter,
      discrete: {
        ...defaultFilter.discrete,
        ...rowFilter
      },
    };
    return filcombinedFilters;
  }

  const getCutPolishSymmetryFromMake = (make) => {
    const makeMap = {
      "0000xxx": { cut: ["0000ex"], polish: ["0000ex"], symmetry: ["0000ex"] },
      "0001x_vgvg_plus": { cut: ["0000ex"], polish: ["0000ex", "0001vg"], symmetry: ["0000ex", "0001vg"] },
      "0002vg_xx": { cut: ["0000ex", "0001vg"], polish: ["0000ex"], symmetry: ["0000ex"] },
      "0003vg_vgvg_plus": { cut: ["0000ex", "0001vg"], polish: ["0000ex", "0001vg"], symmetry: ["0000ex", "0001vg"] },
      "0004vg_gdgd_plus": { cut: ["0000ex", "0001vg"], polish: ["0000ex", "0001vg", "0002good"], symmetry: ["0000ex", "0001vg", "0002good"] },
      "0005gd_xx": { cut: ["0000ex", "0001vg", "0002good"], polish: ["0000ex"], symmetry: ["0000ex"] },
      "0006gd_vgvg_plus": { cut: ["0000ex", "0001vg", "0002good"], polish: ["0000ex", "0001vg"], symmetry: ["0000ex", "0001vg"] },
      "0007gd_gdgd_plus": { cut: ["0000ex", "0001vg", "0002good"], polish: ["0000ex", "0001vg", "0002good"], symmetry: ["0000ex", "0001vg", "0002good"] }
    };
  
    const result = makeMap[make] || { cut: null, polish: null, symmetry: null };
    return [result.cut, result.polish, result.symmetry];
  };
  

  const transformFilters = (filters) => {
    const transformed = {
      item_filter: {
        discrete: {},
        from: {},
        text: {},
        to: {},
      },
    };
  
    // Process discrete filters
    if (filters.discrete) {
      for (const key in filters.discrete) {
        if (filters.discrete.hasOwnProperty(key)) {
          // Exclude gem#carats for now
          if (key !== "gem#carats" && key !== "diamond#make") {
            transformed.item_filter.discrete[key] = filters.discrete[key];
          } else if (key === "gem#carats") {
            // Combine gem#carats ranges into from and to
            const carats = filters.discrete["gem#carats"];
            let min = null;
            let max = null;
            carats.forEach((carat) => {
              if (carat.from !== undefined) {
                min = min !== null ? Math.min(min, parseFloat(carat.from)) : parseFloat(carat.from);
              }
              if (carat.to !== undefined) {
                max = max !== null ? Math.max(max, parseFloat(carat.to)) : parseFloat(carat.to);
              }
            });
            if (min !== null) transformed.item_filter.from["gem#carats"] = min.toString();
            if (max !== null) transformed.item_filter.to["gem#carats"] = max.toString();
          }
        }
      }
    }
  
    // Process rowFilters for carats (assuming it contains gem#carats)
    if (filters.discrete && filters.discrete["diamond#make"]) {
      // console.log(filters.discrete["diamond#make"])
      filters.discrete["diamond#make"].forEach(make => {
        const [cut, polish, symmetry] = getCutPolishSymmetryFromMake(make);
        // console.log(cut, polish, symmetry);
        if (cut) {
          if (!transformed.item_filter.discrete["diamond#cut"]) {
            transformed.item_filter.discrete["diamond#cut"] = [];
          }
          transformed.item_filter.discrete["diamond#cut"].push(...cut);
        }
        if (polish) {
          if (!transformed.item_filter.discrete["diamond#polish"]) {
            transformed.item_filter.discrete["diamond#polish"] = [];
          }
          transformed.item_filter.discrete["diamond#polish"].push(...polish);
        }
        if (symmetry) {
          if (!transformed.item_filter.discrete["diamond#symmetry"]) {
            transformed.item_filter.discrete["diamond#symmetry"] = [];
          }
          transformed.item_filter.discrete["diamond#symmetry"].push(...symmetry);
        }
      });
    }

    for (const key in transformed.item_filter.discrete) {
      if (Array.isArray(transformed.item_filter.discrete[key])) {
        transformed.item_filter.discrete[key] = [...new Set(transformed.item_filter.discrete[key])];
      }
    }
  
    return transformed;
  };

  return (
    <>
      {!DataisLoaded ? (
        <div className="row">
          <ColorRing
            visible={true}
            height="60"
            width="60"
            ariaLabel="blocks-loading"
            wrapperStyle={{}}
            wrapperClass="blocks-wrapper"
            colors={["#00319f", "#2e56b1", "#5c7bc2", "#8aa1d3", "#b2c1e2"]}
          />
          <div className="align-items-center justify-content-center">
            <h3 className=" text-center"> Please wait... </h3>
          </div>
        </div>
      ) : (
        <div class="row">
          {Object.entries(items).map(([key, value]) => {
            // Getting min max amounts of each tables
            const maxValue = Math.max(
              ...value.map((e) => parseCurrencyValue(e.total_amount))
            );
            const minValue = Math.min(
              ...value.map((e) => parseCurrencyValue(e.total_amount))
            );

            // Get min/max for Turn
            const turnValues = value.map(e => parseNumericValue(e.turn)).filter(v => v >= 0);
            const maxTurn = Math.max(...turnValues);
            const minTurn = Math.min(...turnValues);

            const sortedData = getSortedData(key, value);
            
            return (
              <div class="col-xxl-4 col-md-12 col-lg-6 col-sm-12">
                <h5
                  className="card-title"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  {key.toUpperCase()}
                </h5>

                <div
                  className="card"
                  style={{
                    minHeight: "480px",
                    maxHeight: "480px",
                    overflow: "auto",
                  }}
                >
                  <div class="card-body">
                  <table className="table table-sm  table-hover">
                      <thead
                        className="sticky-top bg-white"
                        style={{
                          top: -1,
                          zIndex: 100,
                        }}
                      >
                        <tr>
                          <th 
                            scope="col"
                            className="cursor-pointer min-w-[70px]"
                            onClick={() => handleSort(key, 'name')}
                          >
                            Name {getSortIcon(key, 'name')}
                          </th>
                          <th 
                            scope="col"
                            className="cursor-pointer min-w-[79px]"
                            onClick={() => handleSort(key, 'count')}
                          >
                            Inv Count {getSortIcon(key, 'count')}
                          </th>
                          <th 
                            scope="col"
                            className="cursor-pointer min-w-[78px]"
                            onClick={() => handleSort(key, 'value')}
                          >
                            Inv Value {getSortIcon(key, 'value')}
                          </th>
                          <th 
                            scope="col"
                            className="cursor-pointer min-w-[88px]"
                            onClick={() => handleSort(key, 'sale_count')}
                          >
                          
                            Sale Count {getSortIcon(key, 'sale_count')}
                          
                          </th>
                          <th 
                            scope="col"
                            className="cursor-pointer  min-w-[84px]"
                            onClick={() => handleSort(key, 'sale_value')}
                          >
                            Sale Value {getSortIcon(key, 'sale_value')}
                          </th>
                          <th 
                            scope="col"
                            className="cursor-pointer  min-w-[68px]"
                            onClick={() => handleSort(key, 'turn')}
                          >
                          <Tooltip title='Showing your inventory turn based on annualized sales depending on your sales period'>
                           1Y Turn {getSortIcon(key, 'turn')}
                           
                          </Tooltip>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedData.map((element, idx) => (
                          <tr key={idx} onClick={() => handleRowClick(key, element)}>
                            <td scope="row" style={{ textAlign: "left" }}>
                              {element.name}
                            </td>
                            <td scope="row">{element.count}</td>
                            <td
                              scope="row"
                              style={{
                                backgroundColor: `${getBgColor(
                                  minValue,
                                  maxValue,
                                  parseCurrencyValue(element.total_amount)
                                )}`,
                                opacity: 1,
                              }}
                            >
                              {element.total_amount.slice(0, -3)}
                            </td>
                            <td scope="row">{element.sale_count}</td>
                            <td scope="row">
                              {element.sale_total_amount.slice(0, -3)}
                            </td>
                            <td
                              scope="row"
                              style={{
                                backgroundColor: element.turn === "NA" ? "" : 
                                  `${getBgColor(
                                    minTurn,
                                    maxTurn,
                                    parseNumericValue(element.turn)
                                  )}`,
                                opacity: 1,
                              }}
                            >
                              {element.turn}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default TurnReport;
